module.exports = __webpack_public_path__ + "img/jyns.96f8ed70.jpg";